<template>
  <div class="upload-wrap">
    <el-upload
      class="upload-area"
      :class="{ 'show-list': messageImgs.length > 0, hide: hideUploadEdit }"
      :action="uploadApi"
      :headers="headers"
      :show-file-list="showUploadList"
      list-type="picture-card"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :on-change="handleEditChange"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-error="handleError"
      ref="upload"
      name="uploadFile"
      :data="params"
      :multiple="true"
      :drag="true"
      :limit="limit"
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt="图片"
          @error="errorimg(file)"
        />
        <div v-if="file.status == 'success'" class="tip">上传成功</div>
        <div v-if="file.status == 'uploading'" class="tip">上传中</div>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            v-if="isShowCopy"
            :data="file.url"
            @click="handlePictureCardPreview"
          >
            <i class="el-icon-zoom-in" :data="file.url"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import uploadImg from "src/mixins/uploadImg";
export default {
  name: "upload-image-message",
  mixins: [uploadImg],
  computed: {
    ...mapState({
      messageImgs: state => state.chat.messageImgs,
      showUploadList: state => state.showUploadList
    })
  },
  props: {
    clickbanner: {
      type: Function,
      default: null
    },
    isShowCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hideUploadEdit: false,
      limit: 5
    };
  },
  methods: {
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      this.hideUploadEdit = this.fileList.length >= this.limit;
    },
    errorimg(file) {
      this.$message.closeAll();
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
      this.isMsgUpload = false;
      this.fileList.forEach(element => {
        if (element.status != "success") {
          this.isMsgUpload = true;
          return false;
        }
      });
    },
    submits(blob) {
      const upload = this.$refs.upload;
      // console.log(this.blob);
      upload.handleStart(blob);
      upload.submit();
      //  setTimeout(()=>{
      //     upload.handleStart(that.blob);
      //     upload.submit();
      //  },3000);
      //  console.log(this.blob);
    },
    handlePictureCardPreview(e) {
      this.$parent.clickbanner(e);
      // return e.target.getAttribute("data");
    }
  }
};
</script>
<style lang="less" scoped>
.tip {
  color: #fff;
  z-index: 64;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
}
.upload-wrap {
  width: 100%;
  height: 100%;

  /deep/ .upload-area {
    &.show-list {
      .el-upload-list {
        right: 0;
        border-top: 1px solid #e7e7e7;
      }

      .el-upload-list__item {
        margin: 10px 0 10px 10px;
      }
    }

    .el-upload-list {
      position: absolute;
      top: -81px;
      background: #f3f3f3;
      left: 0;
      width: auto;
      max-width: 100%;
      white-space: nowrap;
      height: 80px;
      border-radius: 5px;
      overflow-y: hidden;
      overflow-x: auto;
    }

    .el-upload-list__item {
      display: inline-block;
      margin: 10px;
      width: 60px;
      height: 60px;
      position: relative;

      img {
        max-width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }

    .el-upload--picture-card {
      width: 20px;
      height: 20px;
      opacity: 0;
      border: 0px dashed var(--loadimg-add-icon);
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 0;
      }
    }
  }
}
.mobile {
  .upload-wrap {
    width: 100%;
    height: 100%;
  }
}
.pc {
  .upload-wrap {
    margin-top: -20px;
  }
}

.app {
  .upload-wrap {
    margin-top: -20px;
  }
}
/*.mobile {*/
/*  .upload-wrap {*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    /deep/ .upload-area {*/
/*      .el-upload-list {*/
/*        position: absolute;*/
/*        top: -91px;*/
/*        background: #858585;*/
/*        left: 0;*/
/*        width: auto;*/
/*        max-width: 100%;*/
/*        white-space: nowrap;*/
/*        overflow-x: scroll;*/
/*        height: 90px;*/
/*        border-radius: 5px;*/
/*      }*/
/*      .el-upload-list__item {*/
/*        display: inline-block;*/
/*        margin: 10px 5px;*/
/*        width: 70px;*/
/*        height: 70px;*/
/*        position: relative;*/
/*        img {*/
/*          max-width: 100%;*/
/*          height: auto;*/
/*          position: absolute;*/
/*          top: 0;*/
/*          left: 0;*/
/*          right: 0;*/
/*          bottom: 0;*/
/*          margin: auto;*/
/*        }*/
/*      }*/
/*      .el-upload--picture-card {*/
/*        width: 20px;*/
/*        height: 20px;*/
/*        opacity: 0;*/
/*      }*/
/*    }*/
/*  }*/
/*}*/

/*.pc {*/
/*  .upload-wrap {*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    margin-top: -20px;*/

/*    /deep/ .upload-area {*/
/*      .el-upload-list {*/
/*        position: absolute;*/
/*        top: -90px;*/
/*        background: #858585;*/
/*        left: 0;*/
/*        width: auto;*/
/*        max-width: 100%;*/
/*        white-space: nowrap;*/
/*        border: 1px solid #ebebeb;*/
/*        border-radius: 5px;*/
/*        height: 90px;*/
/*        display: flex;*/
/*        align-items: center;*/
/*      }*/
/*      .el-upload-list__item {*/
/*        display: inline-block;*/
/*        margin: 0 3px 0 3px;*/
/*        width: 70px;*/
/*        height: 70px;*/
/*      }*/
/*      .el-upload--picture-card {*/
/*        width: 20px;*/
/*        height: 20px;*/
/*        opacity: 0;*/
/*      }*/
/*    }*/
/*  }*/
/*}*/

/*.app {*/
/*  .upload-wrap {*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    /deep/ .upload-area {*/
/*      .el-upload-list {*/
/*        position: absolute;*/
/*        top: -91px;*/
/*        background: #f3f3f3;*/
/*        left: 0;*/
/*        width: auto;*/
/*        max-width: 100%;*/
/*        white-space: nowrap;*/
/*        height: 90px;*/
/*        border-radius: 5px;*/
/*        overflow-y: hidden;*/
/*        overflow-x: auto;*/
/*      }*/

/*      .el-upload-list__item {*/
/*        display: inline-block;*/
/*        margin: 5px 3px 5px 3px;*/
/*        width: 70px;*/
/*        height: 70px;*/
/*      }*/

/*      .el-upload--picture-card {*/
/*        width: 20px;*/
/*        height: 20px;*/
/*        opacity: 0;*/
/*        .el-upload-dragger {*/
/*          width: 100%;*/
/*          height: 100%;*/
/*          display: flex;*/
/*          justify-content: center;*/
/*          align-items: center;*/
/*          border: 0;*/
/*        }*/
/*      }*/
/*    }*/
/*  }*/
/*}*/
</style>
